<template>
  <div class="member-evaluation-mistake" v-loading="loading">
    <EvaluationEmpty v-show="!loading && isEmpty"></EvaluationEmpty>
    <div v-show="!loading && !isEmpty">
      <div class="total">
        <p class="num">{{ totalNum }}</p>
        <p class="label">错题数</p>
        <div class="btn-wrap">
          <el-button type="primary" size="medium" @click="onConsolidate(null)">
            巩固全部错题
          </el-button>
        </div>
        <div class="switch-wrap">
          <span class="label">答对后自动移除错题</span>
          <el-switch
            v-model="autoRemove"
            :active-value="2"
            :inactive-value="1"
            @change="onSwitchChange"
          ></el-switch>
        </div>
      </div>
      <div class="detail">
        <ul class="tabs-simple">
          <li
            v-for="(item, index) in tabs"
            :key="index"
            :class="{ active: item.type == searchCondition.type }"
            @click="onTab(item)"
          >
            {{ item.label }}（{{ item.num }}）
          </li>
        </ul>
        <TreeCollapse
          :value="treeData"
          :header-title="['名称', '题目数', '操作']"
          child-prop="child"
          :max-level="2"
        >
          <template slot="num" slot-scope="{ data }">
            {{ data.ques_num || "--" }}
          </template>
          <template slot="btn" slot-scope="{ data }">
            <el-button
              type="primary"
              size="small"
              @click="onConsolidate(data)"
              :disabled="!data.ques_num"
            >
              巩固错题
            </el-button>
          </template>
        </TreeCollapse>
      </div>
    </div>
    <LimitModal ref="limitModal" />
  </div>
</template>

<script>
import TreeCollapse from "../exam/components/TreeCollapse";
import EvaluationEmpty from "./EvaluationEmpty";
export default {
  name: "member-evaluation-mistake",
  components: {
    TreeCollapse,
    EvaluationEmpty,
  },
  data() {
    return {
      questionType: "套卷练习",
      isEmpty: true,
      loading: true,
      tabs: [
        { type: 1, label: "知识点分类", num: 0 },
        { type: 3, label: "专项练习", num: 0 },
        { type: 2, label: "套卷练习", num: 0 },
      ],
      totalNum: 0,
      searchCondition: {
        type: 1,
      },
      treeData: [],
      autoRemove: 1,
      visible: false,
    };
  },
  created() {
    this.requestData();
  },
  mounted() {},
  methods: {
    // on event
    onSwitchChange(val) {
      this.$http
        .post(
          "/api/app/myExam/rightRemove",
          {
            auto_remove_qb_wrong: val,
          },
          { showLoading: false },
        )
        .then(() => {
          this.$success("设置成功");
        });
    },
    onTab(item) {
      this.searchCondition.type = item.type;
      this.requestData();
    },
    async onConsolidate(val) {
      //判断错题集练习免费答题次数是否用完
      await this.$refs.limitModal.checkAnswer("error", "错题集");
      let query = {
        type: val ? this.searchCondition.type : 0,
        name: val ? val.name : "",
        from: "mistake",
        examType: "错题集",
      };
      if (query.type == 1) {
        query.point_id = val.id;
      } else if (query.type == 2) {
        if (val.is_can_do && val.is_can_do == 2) {
          //会员过期
          this.visible = true;
          this.questionType = "套卷练习";
          return;
        } else if (val.is_can_do && val.is_can_do == 3) {
          //判断有没有权限进入套卷练习
          this.$message.warning("您没有权限进入");
          return;
        }
        query.exam_id = val.id;
      } else if (query.type == 3) {
        query.practise_id = val.id;
      }
      this.$router.push({
        name: "ExamWrongDo",
        query: query,
      });
    },
    // other
    getData() {
      this.requestData();
    },
    setNum(type, num) {
      for (const item of this.tabs) {
        if (item.type == type) {
          item.num = num;
          break;
        }
      }
    },
    // request
    async requestData() {
      this.loading = true;
      let data = await this.$http.post(
        "/api/app/myExam/errorRecord",
        this.searchCondition,
        {
          showLoading: false,
        },
      );
      this.setNum(1, data.konw_num);
      this.setNum(3, data.spec_num);
      this.setNum(2, data.exam_num);
      this.totalNum = data.question_num;
      this.treeData = data.question_list;

      data = await this.$http.get(
        "/api/app/myExam/rightRemove",
        {},
        {
          showLoading: false,
        },
      );
      this.autoRemove = +data.auto_remove_qb_wrong;
      this.loading = false;
      this.isEmpty = !this.totalNum;
    },
  },
};
</script>

<style lang="scss" scoped>
.member-evaluation-mistake {
  min-height: 738px;
  .total {
    text-align: center;
    position: relative;
    border-bottom: 1px solid #ededed;
    padding: 15px 0 30px;
    margin-bottom: 27px;
    .num {
      color: #333;
      font-size: 42px;
      line-height: 1;
      font-weight: 500;
      margin-bottom: 11px;
    }
    .label {
      color: #666;
      font-size: 15px;
      line-height: 1;
      margin-bottom: 19px;
    }
    .switch-wrap {
      position: absolute;
      top: 0;
      right: 0;
      .label {
        color: #999;
        font-size: 16px;
        margin-right: 19px;
        vertical-align: middle;
      }
    }
  }
  .detail {
    .tabs-simple {
      margin-bottom: 15px;
    }
  }
}
</style>
